import { faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SwipeableList, SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ViewHelper from '../../helpers/ViewHelper';
import Item from './Item';

class ItemList extends Component {
  render() {
    return (
      <>
        {this.renderItems(
          this.props.location,
          this.props.items,
          this.props.categories,
          this.props.promotions,
          this.props.selectedOutlet
        )}
      </>
    );
  }

  // shouldComponentUpdate(nextProps) {
  //   if (
  //     this.props.items?.length === nextProps.items?.length &&
  //     this.props.outlets?.length === nextProps.outlets?.length
  //   ) {
  //     return false;
  //   }
  //   return true;
  // }

  onItemSelected(item) {
    this.props.onItemSelected(item);
  }

  renderItems(location, items, categories, promotions, selectedOutlet) {
    const groupedItems = _.groupBy(items, 'menu_category_id');
    const menuByCategory = (menu_category_id) => {
      if (location?.outstock_items_visibility === 1) {
        return items.filter((p) => p.menu_category_id === menu_category_id && (p.menu_status === 1 || p.menu_status === 2));
      } else {
        return items.filter((p) => p.menu_category_id === menu_category_id && (p.menu_status === 1));
      }
    };
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : '';
    const card_shadow = this.props.locationSettings.card_shadow_enable === 1 ? 'hovernowshodow' : '';
    return _.map(categories, (category, parent_index) => {
      let status = 0;
      if (location.is_outlet) {
        status = this.getCategoryStatusForItem(category, selectedOutlet);
      } else {
        status = selectedOutlet &&
          selectedOutlet.categoryStatuses &&
          selectedOutlet.categoryStatuses[category.category_id]
          ? selectedOutlet.categoryStatuses[category.category_id].status_id
          : category.status;
      }

      if (status === 0) {
        return null;
      }
      let grid_classname =
        this.props.layout === 'default'
          ? 'grid-layout-items'
          : this.props.layout === 'large_grid'
            ? 'large-grid-layout'
            : 'small-grid-layout';

      if (this.props.layout === 'old') {
        return (
          <section
            className="items"
            data-category-id={`category-${category.category_id}`}
            key={`category-${category.category_id}`}
          >
            <h4 className="f1 category-name mb-2 primary-font-color">{category.name}</h4>
            <div className="container-fluid">
              <div className="row">
                {groupedItems[category.category_id]?.map((it) => {
                  const item = JSON.parse(JSON.stringify(it));
                  const { menu_price, menu_id, menu_category_id } = item;
                  if (location.is_outlet) {
                    item.menu_status = this.getMenuStatusForItem(item, selectedOutlet);
                  } else {
                    item.menu_status =
                      selectedOutlet &&
                        selectedOutlet.stockStatuses &&
                        selectedOutlet.stockStatuses[menu_id]
                        ? selectedOutlet.stockStatuses[menu_id].status_id
                        : item.menu_status;
                  }
                  if (selectedOutlet?.outstock_items_visibility === 0) {
                    if (item.menu_status === 2) {
                      return null;
                    }
                  }
                  if (item.menu_status === 0) {
                    return null;
                  }
                  item.discounts = ViewHelper.getDiscountedItemPrice(
                    menu_price,
                    menu_id,
                    menu_category_id,
                    this.props.promotions,
                    this.props.order_type_id,
                    selectedOutlet ? selectedOutlet.orderTypes : location.orderTypes
                  );

                  return (
                    <React.Fragment>
                      <div className="col-lg-6 col-md-12  card_layout card_layout_top card_layout_bottom">
                        <div
                          onClick={(e) => {
                            let menu_name = item.menu_name.replace(/ /g, '-');
                            this.props.redirectToItem(
                              `/${location.slug}/item/${menu_name}-${item.menu_id}`,
                              item
                            )
                          }
                          }
                          className={`hovernow ${card_shadow} ${card_outline}`}
                        >
                          <SwipeableList threshold={0.1}>
                            <SwipeableListItem
                              blockSwipe={
                                !location.location_status ||
                                this.props.reviewAble ||
                                item.menu_status === 2
                              }
                              key={item.menu_id}
                              swipeLeft={this.swipeContent(item, 'left', this.props.removeFromCart)}
                              swipeRight={this.swipeContent(item, 'right', this.props.addToCart)}
                            >
                              <Item
                                grid_layout={this.props.layout}
                                isOrderingEnabled={this.props.isOrderingEnabled}
                                addToCart={this.props.addToCart}
                                removeFromCart={this.props.removeFromCart}
                                _location={this.props.location}
                                item={item}
                                dailyLimitCategory={category.daily_limit > 0 ? category.daily_limit : 0}
                                onItemClick={this.onItemSelected.bind(this, item)}
                                reviewAble={this.props.reviewAble}
                                selectedItems={this.props.selectedItems}
                                onSelectItem={this.props.onSelectItem}
                                onRemoveItem={this.props.onRemoveItem}
                                promotions={this.props.promotions}
                                locationSettings={this.props.locationSettings}
                              />
                            </SwipeableListItem>
                          </SwipeableList>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          </section>
        );
      } else if (this.props.layout !== 'old') {
        return (
          categories.length >= 1 && menuByCategory(category.category_id).length > 0 ?
            <section
              className={
                this.props.layout === 'old' ? `items` : `items items-custom ${grid_classname} mb-3`
              }
              data-category-id={`category-${category.category_id}`}
              id={`data-category-${category.category_id}`}
              key={`category-${category.category_id}`}
            >

              <h1
                className={
                  parent_index !== 0
                    ? 'f1 custom-category-name custom-category-pt mb-2 primary-font-color'
                    : 'f1 custom-category-name mb-2 custom-category-name-1 primary-font-color'
                }
              >
                {category.name}
              </h1>
              <div className="container-fluid" style={{ height: '100%' }}>
                <div className="row">
                  {menuByCategory(category.category_id).map((it, child_index) => {
                    const item = JSON.parse(JSON.stringify(it));
                    const { menu_price, menu_id, menu_category_id } = item;
                    if (location.is_outlet) {
                      item.menu_status = this.getMenuStatusForItem(item, selectedOutlet);
                    } else {
                      item.menu_status =
                        selectedOutlet &&
                          selectedOutlet.stockStatuses &&
                          selectedOutlet.stockStatuses[menu_id]
                          ? selectedOutlet.stockStatuses[menu_id].status_id
                          : item.menu_status;
                    }
                    if (selectedOutlet?.outstock_items_visibility === 0) {
                      if (item.menu_status === 2) {
                        return null;
                      }
                    }
                    if (item.menu_status === 0) {
                      return null;
                    }

                    item.discounts = ViewHelper.getDiscountedItemPrice(
                      menu_price,
                      menu_id,
                      menu_category_id,
                      this.props.promotions,
                      this.props.order_type_id,
                      selectedOutlet ? selectedOutlet.orderTypes : location.orderTypes
                    );
                    return (
                      <React.Fragment key={child_index}>
                        <div

                          className={
                            this.props.layout === 'old'
                              ? `col-lg-6 col-md-6 mt-1 mb-3`
                              : `col-lg-6 col-md-6 mt-1 mb-3 card_layout_custom`
                          }
                        >
                          <div
                            onClick={(e) => {
                              let menu_name = item.menu_name.replace(/ /g, '-');
                              this.props.redirectToItem(
                                `/${location.slug}/item/${menu_name}-${item.menu_id}`,
                                item
                              )
                            }
                            }
                            className={`hovernow ${card_shadow} ${card_outline}`}
                          >
                            <SwipeableList threshold={0.1}>
                              <SwipeableListItem
                                blockSwipe={true}
                                key={item.menu_id}
                                swipeLeft={this.swipeContent(item, 'left', this.props.removeFromCart)}
                                swipeRight={this.swipeContent(item, 'right', this.props.addToCart)}
                              >
                                <Item
                                  grid_layout={this.props.layout}
                                  parent_index={parent_index}
                                  child_index={child_index}
                                  isOrderingEnabled={this.props.isOrderingEnabled}
                                  addToCart={this.props.addToCart}
                                  removeFromCart={this.props.removeFromCart}
                                  _location={this.props.location}
                                  item={item}
                                  dailyLimitCategory={category.daily_limit > 0 ? category.daily_limit : 0}
                                  onItemClick={this.onItemSelected.bind(this, item)}
                                  reviewAble={this.props.reviewAble}
                                  selectedItems={this.props.selectedItems}
                                  onSelectItem={this.props.onSelectItem}
                                  onRemoveItem={this.props.onRemoveItem}
                                  promotions={this.props.promotions}
                                  locationSettings={this.props.locationSettings}
                                />

                              </SwipeableListItem>
                            </SwipeableList>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </section>
            : ''

        );
      }
    });
  }

  getMenuStatusForItem(item, selectedOutlet) {
    let outlet;
    if (!this.props.outlets) {
      return item.menu_status;
    }
    for (const o of this.props.outlets) {
      if (this.props.location.loc_id === o.loc_id) {
        outlet = o;
        break;
      }
    }
    const outlet_status = outlet && outlet.stockStatuses[item.menu_id];
    if (outlet_status) {
      return outlet_status.status_id;
    }
    return item.menu_status;
  }

  getCategoryStatusForItem(category, selectedOutlet) {
    let outlet;
    if (!this.props.outlets) {
      return category.status;
    }
    for (const o of this.props.outlets) {
      if (this.props.location.loc_id === o.loc_id) {
        outlet = o;
        break;
      }
    }
    const outlet_status = outlet && outlet.categoryStatuses[category.category_id];

    if (outlet_status) {
      return outlet_status.status_id;
    }
    return category.status;
  }

  swipeContent(item, direction, action) {
    return {
      content: (
        <div className={`${direction}-swipe`}>
          <FontAwesomeIcon icon={swipeIcons[direction]} />
        </div>
      ),
      action: () => {
        action(item);
      }
    };
  }
}

const swipeIcons = {
  right: faPlus,
  left: faTrashAlt
};

function mapStateToProps(state) {
  const { locationSettings } = state;
  return { locationSettings };
}

export default connect(mapStateToProps)(ItemList);
